import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {useLinkResolver} from 'prismicio'
import type {Context} from 'src/common/types'
import {DefaultStresstimonialsCard} from './Default'
import {TwoCardsStresstimonialsCard} from './TwoCards'

/**
 * Props for `StresstimonialsCard`.
 */
export type StresstimonialsCardProps = SliceComponentProps<Content.StresstimonialsCardSlice>

/**
 * Component for "StresstimonialsCard" Slices.
 */
const StresstimonialsCard = ({
  slice,
  context: {pageUid, buttonsData},
  index: componentIndex,
}: StresstimonialsCardProps & {context: Context}): JSX.Element => {
  const {linkResolver} = useLinkResolver()

  switch (slice.variation) {
    case 'twoCards':
      return (
        <TwoCardsStresstimonialsCard
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          linkResolver={linkResolver}
          buttonsData={buttonsData}
        />
      )
    default:
      return (
        <DefaultStresstimonialsCard
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          buttonsData={buttonsData}
        />
      )
  }
}

export default StresstimonialsCard
